import Header from "./components/header";
import Footer from "./components/footer";
const PrivacyPolicy = () => {
  return (
    <>
      <Header />
      <section class="MainSection">
        <div class="container">
          <h1 class="Head_2">TAK8 Car Rental Privacy Policy</h1>

        </div>
      </section>
      <section className="TermsSection">
        <div class="container">
          <div className="Text">
            <h4 className="Head_3">Introduction</h4>
            <p className="Pra_1">
              TAK8 Car Rental ("we," "our," "us") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website (https://tak8.com.au/) and use our services. Please read this policy carefully to understand our views and practices regarding your personal data and how we will treat it.
            </p>
          </div>
          <div className="TextAlt">
            <h4 className="Head_3">Personal Information We Collect</h4>
            <p className="Pra_1">
              When you visit the Site or make a booking request, we collect certain information about you and your device. This may include:
            </p>
            <ul>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>Personal Identification Information</b> Name, address, email address, phone number, date of birth, driver's license details, and payment information.</li>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>Device Information</b> Information about your web browser, IP address, time zone, and some of the cookies installed on your device.</li>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>Browsing Information</b> Information about the individual web pages or products that you view, what websites or search terms referred you to the Site, and information about how you interact with the Site.</li>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>Location Data</b> GPS data from rented vehicles for tracking and safety purposes.</li>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>Communication Data</b> Records of your communications with us, including emails, phone calls, and messages.</li>
            </ul>

          </div>

          <div className="Text">
            <h4 className="Head_3">How Do We Use Your Personal Information?</h4>

            <p className="Pra_1">
              We use the information we collect in the following ways
            </p>
            <ul>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>To Provide Services</b> Process your rental bookings, manage your rental agreements, and provide customer support.</li>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>To Improve Our Services</b> Analyze usage trends, improve our website and services, and develop new features.</li>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>For Marketing</b> Send you promotional materials, newsletters, and other information about our services (you can opt out at any time).</li>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>For Safety and Security</b> Ensure the safety and security of our customers, employees, and property, including tracking rented vehicles.</li>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>Legal Compliance</b> Comply with legal obligations, resolve disputes, and enforce our agreements.</li>
            </ul>
          </div>
          <div className="TextAlt">
            <h4 className="Head_3">Sharing Your Personal Information</h4>

            <p className="Pra_1">
              We may share your personal information with third parties in the following circumstances
            </p>
            <ul>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>Service Providers</b> Third-party vendors who perform services on our behalf, such as payment processing, customer support, and marketing.</li>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>Business Partners</b> Partners with whom we collaborate to provide services, including insurance companies and roadside assistance providers.</li>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>Legal Authorities</b> Government authorities and law enforcement agencies when required by law or to protect our rights and interests.</li>
              <li><img src="img/icon/dot.svg" alt="Check" /><b>Affiliates</b> Our subsidiaries and affiliated companies for business purposes.</li>
            </ul>

          </div>
          <div className="Text">
            <h4 className="Head_3">Behavioural Advertising</h4>

            <p className="Pra_1">
              We use your personal information to provide you with targeted advertisements or marketing communications we believe may be of interest to you. For more information about how targeted advertising works, you can visit the Network Advertising Initiative’s ("NAI") educational page at here.
            </p>
            <p className="Pra_1">You can opt out of targeted advertising by</p>
            <ul>
              <li><img src="img/icon/dot.svg" alt="Check" />Facebook</li>
              <li><img src="img/icon/dot.svg" alt="Check" />Google</li>
              <li><img src="img/icon/dot.svg" alt="Check" />Bing</li>
            </ul>
            <p className="Pra_1">
              Additionally, you can opt out of some of these services by visiting the Digital Advertising Alliances opt-out portal at http://optout.aboutads.info/.
            </p>
          </div>
          <div className="TextAlt">
            <h4 className="Head_3">Do Not Track</h4>

            <p className="Pra_1">
              Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track signal from your browser.

            </p>

          </div>
          <div className="Text">
            <h4 className="Head_3">Your Rights</h4>

            <p className="Pra_1">
              If you are a European resident, you have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. If you would like to exercise this right, please contact us through the contact information below.
            </p>
            <p className="Pra_1">
              Additionally, if you are a European resident, we note that we are processing your information to fulfill contracts we might have with you (for example, if you make a quote request or a booking through the Site), or otherwise to pursue our legitimate business interests listed above. Additionally, please note that your information will be transferred outside of Europe, including to Australia and the United States.
            </p>
          </div>
          <div className="TextAlt">
            <h4 className="Head_3">Data Retention</h4>

            <p className="Pra_1">
              When you place a request through the Site, we will maintain your Form Information for our records unless and until you ask us to delete this information.
            </p>

          </div>
          <div className="Text">
            <h4 className="Head_3">Changes</h4>

            <p className="Pra_1">
              We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal, or regulatory reasons.

            </p>

          </div>
          <div className="TextAlt">
            <h4 className="Head_3">Contact Us</h4>

            <p className="Pra_1">
              For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e-mail at info@tak8.com.au or by mail using the details provided below
            </p>
            <li><b>Address</b> : TAK8 Car Rental 17 Regal Place East Perth</li>
            <li><b>Email</b> :  info@tak8.com.au</li>
          </div>
        </div >

      </section >
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
